import axios from 'axios';

// Configurações da API - usando variável de ambiente
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

// Instância do axios com configurações padrão
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interfaces para tipagem
interface CustomerData {
  personType: 'fisica' | 'juridica';
  tipoContato?: string;
  firstName: string;
  lastName: string;
  companyName: string;
  email: string;
  phone: string;
  cpf: string;
  cnpj: string;
  birthDate: string;
  gender: string;
  address: {
    street: string;
    number: string;
    complement: string;
    neighborhood: string;
    city: string;
    state: string;
    zipCode: string;
  };
  acceptTerms: boolean;
  acceptMarketing: boolean;
  // Anti-bot
  website?: string;
}





// Função principal para criar cliente
export const createCustomer = async (data: CustomerData): Promise<any> => {
  try {
    // Usar a rota principal do backend que gerencia Shopify e Kommo
    const response = await api.post('/customers', data);
    return response.data;
  } catch (error: any) {
    console.error('Erro ao criar cliente:', error);
    throw error;
  }
};

// Função para validar CPF via API (opcional)
export const validateCPF = async (cpf: string): Promise<boolean> => {
  try {
    const response = await api.post('/validate/cpf', { cpf });
    return response.data.valid;
  } catch (error) {
    console.error('Erro ao validar CPF:', error);
    return false;
  }
};

// Função para buscar CEP
export const getAddressByCEP = async (cep: string): Promise<any> => {
  try {
    const cleanCEP = cep.replace(/\D/g, '');
    const response = await axios.get(`https://viacep.com.br/ws/${cleanCEP}/json/`);
    
    if (response.data.erro) {
      throw new Error('CEP não encontrado');
    }
    
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar CEP:', error);
    throw new Error('Erro ao buscar endereço pelo CEP');
  }
};

// Interceptor para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Erro do servidor
      const message = error.response.data?.message || 'Erro interno do servidor';
      throw new Error(message);
    } else if (error.request) {
      // Erro de rede
      throw new Error('Erro de conexão. Verifique sua internet.');
    } else {
      // Outro erro
      throw new Error('Erro inesperado');
    }
  }
);

export default api; 